// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;

      $( '#geocode-providers' ).on( 'click', function() {
        $( '.progress-bar .progress' ).width( '0%' );
        $( '.processed-providers-log' ).html( '' );
        $( '.setup-buttons' ).addClass( 'is-disabled' );
        $( '.loader' ).addClass( 'is-loading' );
        geocodeAddresses();
      } );

      $( '#generate-taxonomies' ).on( 'click', function() {
        $( '.progress-bar .progress' ).width( '0%' );
        $( '.geocoded-providers-log' ).html( '' );
        $( '.setup-buttons' ).addClass( 'is-disabled' );
        $( '.loader' ).addClass( 'is-loading' );
        generateTerms();
      } );

      function geocodeAddresses( paged = null ) {
        const numToGeocodeAtATime = 10;
        $.ajax( {
          type: 'GET',
          url: site_info.wpApiSettings.ll + 'cpt/setup_provider_geocoding',
          data: {
            page_id: $( '.setup-providers' ).attr( 'data-id' ),
            num: numToGeocodeAtATime,
            paged: paged ? paged : 1,
          },
          beforeSend: function( xhr ) {
            xhr.setRequestHeader( 'X-WP-Nonce', site_info.wpApiSettings.nonce );
            xhr.setRequestHeader( 'X-Requested-With', 'XMLHttpRequest' );
            doingAjax = true;
          },
          success: function( data ) {
            console.log( data );
            // Continue running this function until all address have been geocoded. Typically
            // I would just run this one time, but if there are 4000+, we need a way to see
            // if/when/where it stops or times out. Or at the very least, let the user know
            // it is still working through it.
            if ( ( parseInt( data.totalGeocoded ) <= parseInt( data.totalProviders ) ) ) {
              geocodeAddresses( data.paged );
              $( '.geocoded-providers-log' ).append( '<p>Geocoding next ' + numToGeocodeAtATime + ' providers... (Geocoded ' + data.totalGeocoded + ' of ' + data.totalProviders + ')' );
              $( '.progress-bar .progress' ).width( ( ( data.totalGeocoded / data.totalProviders ) * 100 ) + '%' );
            } else {
              console.log( 'Done geocoding providers.' );
              $( '.progress-bar .progress' ).width( '100%' );
              $( '.geocoded-providers-log' ).append( '<p>Geocoded all providers.</p>' );
              $( '#geocode-providers' ).next().find( 'span' ).text( data.date );
              $( '.setup-buttons' ).removeClass( 'is-disabled' );
              $( '.loader' ).removeClass( 'is-loading' );

              setTimeout( function() {
                alert( data.response );
              }, 1000 );
            }
          },
          complete: function( jqXHR, status ) {
            doingAjax = false;
          },
        } );
      }

      function generateTerms( paged = null ) {
        const numToProcessAtATime = 10;
        $.ajax( {
          type: 'GET',
          url: site_info.wpApiSettings.ll + 'cpt/setup_provider_assign_terms',
          data: {
            page_id: $( '.setup-providers' ).attr( 'data-id' ),
            num: numToProcessAtATime,
            paged: paged ? paged : 1,
          },
          beforeSend: function( xhr ) {
            xhr.setRequestHeader( 'X-WP-Nonce', site_info.wpApiSettings.nonce );
            xhr.setRequestHeader( 'X-Requested-With', 'XMLHttpRequest' );
            doingAjax = true;
          },
          success: function( data ) {
            console.log( data );
            if ( ( parseInt( data.totalProcessed ) <= parseInt( data.totalProviders ) ) ) {
              generateTerms( data.paged );
              $( '.processed-providers-log' ).append( '<p>Processing next ' + numToProcessAtATime + ' providers... (Processed ' + data.totalProcessed + ' of ' + data.totalProviders + ')' );
              $( '.progress-bar .progress' ).width( ( ( data.totalProcessed / data.totalProviders ) * 100 ) + '%' );
            } else {
              console.log( 'Done processing providers.' );
              $( '.progress-bar .progress' ).width( '100%' );
              $( '.processed-providers-log' ).append( '<p>Generated taxonomies for all providers.</p>' );
              $( '#geocode-providers' ).next().find( 'span' ).text( data.date );
              $( '.setup-buttons' ).removeClass( 'is-disabled' );
              $( '.loader' ).removeClass( 'is-loading' );

              setTimeout( function() {
                alert( data.response );
              }, 1000 );
            }
          },
          complete: function( jqXHR, status ) {
            $( '.setup-buttons' ).removeClass( 'is-disabled' );
            $( '.loader' ).removeClass( 'is-loading' );
            doingAjax = false;
          },
        } );
      }
    },
    finalize: function() {
    },
  };
  app.registerComponent( 'setup-providers', COMPONENT );
} )( app );
